import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { OPS, DIRECTIONS, SEASONS } from "@/lib/alerts";
import { ALERTS } from "@/constants/testIds";

const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <Label className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground">{label}</Label>
    {children}
  </div>
);

const num = (v) => (v === "" ? "" : Number(v));

// Controlled per-method config editor. props: method, config, onChange(config)
export function AlertMethodFields({ method, config, onChange }) {
  const set = (patch) => onChange({ ...config, ...patch });

  if (method === "threshold") {
    return (
      <div className="grid grid-cols-2 gap-3">
        <Field label="Operator">
          <Select value={config.op || "<"} onValueChange={(v) => set({ op: v })}>
            <SelectTrigger data-testid={ALERTS.thresholdOp} className="bg-card/60"><SelectValue /></SelectTrigger>
            <SelectContent>{OPS.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Field label="Threshold">
          <Input data-testid={ALERTS.thresholdValue} type="number" value={config.threshold ?? 0}
            onChange={(e) => set({ threshold: num(e.target.value) })} className="bg-card/60" />
        </Field>
      </div>
    );
  }

  if (method === "pct_change") {
    return (
      <div className="grid grid-cols-3 gap-3">
        <Field label="Period (days)">
          <Input data-testid={ALERTS.pctPeriod} type="number" value={config.period_days ?? 7}
            onChange={(e) => set({ period_days: num(e.target.value) })} className="bg-card/60" />
        </Field>
        <Field label="Move %">
          <Input data-testid={ALERTS.pctDrop} type="number" value={config.drop_pct ?? 20}
            onChange={(e) => set({ drop_pct: num(e.target.value) })} className="bg-card/60" />
        </Field>
        <Field label="Direction">
          <Select value={config.direction || "down"} onValueChange={(v) => set({ direction: v })}>
            <SelectTrigger data-testid={ALERTS.pctDirection} className="bg-card/60"><SelectValue /></SelectTrigger>
            <SelectContent>{DIRECTIONS.map((d) => <SelectItem key={d.value} value={d.value}>{d.label}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
      </div>
    );
  }

  if (method === "zscore") {
    return (
      <div className="grid grid-cols-3 gap-3">
        <Field label="Window (pts)">
          <Input data-testid={ALERTS.zWindow} type="number" value={config.window ?? 30}
            onChange={(e) => set({ window: num(e.target.value) })} className="bg-card/60" />
        </Field>
        <Field label="Sensitivity (σ)">
          <Input data-testid={ALERTS.zSensitivity} type="number" step="0.1" value={config.sensitivity ?? 3}
            onChange={(e) => set({ sensitivity: num(e.target.value) })} className="bg-card/60" />
        </Field>
        <Field label="Direction">
          <Select value={config.direction || "both"} onValueChange={(v) => set({ direction: v })}>
            <SelectTrigger data-testid={ALERTS.zDirection} className="bg-card/60"><SelectValue /></SelectTrigger>
            <SelectContent>{DIRECTIONS.map((d) => <SelectItem key={d.value} value={d.value}>{d.label}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
      </div>
    );
  }

  // seasonal
  return (
    <div className="grid grid-cols-3 gap-3">
      <Field label="Sensitivity (σ)">
        <Input data-testid={ALERTS.seasonSensitivity} type="number" step="0.1" value={config.sensitivity ?? 2.5}
          onChange={(e) => set({ sensitivity: num(e.target.value) })} className="bg-card/60" />
      </Field>
      <Field label="Season">
        <Select value={config.season || "dow"} onValueChange={(v) => set({ season: v })}>
          <SelectTrigger data-testid={ALERTS.seasonType} className="bg-card/60"><SelectValue /></SelectTrigger>
          <SelectContent>{SEASONS.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="Direction">
        <Select value={config.direction || "both"} onValueChange={(v) => set({ direction: v })}>
          <SelectTrigger data-testid={ALERTS.seasonDirection} className="bg-card/60"><SelectValue /></SelectTrigger>
          <SelectContent>{DIRECTIONS.map((d) => <SelectItem key={d.value} value={d.value}>{d.label}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
    </div>
  );
}
